import React from "react";
import { useTranslation } from "react-i18next";

import DupontButton from "../DupontButton";

import { DownloadIcon } from "../../assets/icons";

import { getSupportedFileTypes } from "../../utils/appUtils";

const SupportedFileInfo = ({
  supportedFileTypes,
  maxFileSize,
  templateFileName,
  onTemplateDownload,
}) => {
  const { t } = useTranslation();

  const path = `assets/${templateFileName}`;
  const triggerStaticDownload = () => {
    const a = document.createElement("a");
    a.href = path;
    a.download = templateFileName;
    a.click();
  };

  const downloadTemplate = () => {
    if (typeof onTemplateDownload === "function") {
      Promise.resolve(onTemplateDownload()).catch(triggerStaticDownload);
      return;
    }

    triggerStaticDownload();
  };

  return (
    <div className="supported-file-info">
      <p className="type">
        {getSupportedFileTypes(supportedFileTypes)} {t("fileUpload.allowed")}
      </p>

      {Boolean(templateFileName) && (
        <DupontButton
          type="tertiary"
          customClass="download-button-cip-template"
          onClick={downloadTemplate}
        >
          <DownloadIcon className="download-icon" />
          {t("ValueStrings.downloadTemplate")}
        </DupontButton>
      )}
      <p className="size">
        {t("fileUpload.maxSize")} {maxFileSize}
      </p>
    </div>
  );
};

export default SupportedFileInfo;
